import React from 'react'
import { useRouteMatch } from 'react-router-dom'

import { ColumnLayout } from '@/components'
import { routes } from '@/routes'

import { SinglePost } from './single-post.component'
import s from './single-post.module.less'

export const SinglePostContainer = () => {
  const match = useRouteMatch<{ postId: string }>(routes.posts.page(':postId'))!

  const postId = Number(match.params.postId)

  const middle = (
    <div className={s.container}>
      <SinglePost postId={postId} />
    </div>
  )

  return <ColumnLayout middle={middle} />
}
